var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuros(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.324 17.523l8.864-8.866a.185.185 0 00.054-.148l-.598-7.064a.376.376 0 00-.342-.342L9.238.507a.182.182 0 00-.148.054L.226 9.425a.188.188 0 000 .265l7.833 7.833a.184.184 0 00.265 0zM11.2 5.021a1.127 1.127 0 011.591 0c.438.439.438 1.151 0 1.592a1.127 1.127 0 01-1.591 0 1.127 1.127 0 010-1.592zm6.651 6.631l-.928-.926a.188.188 0 00-.265 0l-8.484 8.468-5.569-5.554a.188.188 0 00-.265 0l-.928.925a.188.188 0 000 .265l5.7 5.69.928.927a.188.188 0 00.265 0l9.546-9.53a.188.188 0 000-.265z",
    fill: "#fff"
  })));
}
export default SvgJuros;